import { Space, Tooltip, Typography, Flex } from 'antd';
import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const MessageStatus = ({ status, isCustomerMessage, isDarkMode, sentAt }) => {
    const { t } = useTranslation();
    const statusColor = isDarkMode && isCustomerMessage ? 'rgba(255, 255, 255, 0.8)' : undefined;
    return (
        <Space size={1}>
            {sentAt && (
                <Tooltip title={`${t('sent_at')} ${format(parseISO(sentAt), 'HH:mm')}`}>
                    <Text style={{ color: statusColor, fontSize: '10px' }}>✓</Text>
                </Tooltip>
            )}
            {status.delivered && (
                <Tooltip title={`${t('delivered_at')} ${format(parseISO(status.delivered_at), 'HH:mm')}`}>
                    <Text style={{ color: statusColor, fontSize: '10px' }}>✓</Text>
                </Tooltip>
            )}
            {status.read && (
                <Tooltip title={`${t('read_at')} ${format(parseISO(status.read_at), 'HH:mm')}`}>
                    <Text style={{ color: statusColor, fontSize: '10px' }}>✓</Text>
                </Tooltip>
            )}
        </Space>
    );
};

const MessageMetadata = ({
    message,
    isCustomerMessage,
    isDarkMode,
    isFacebookPolicyError,
    messageAbuseTagColor
}) => {
    const messageTimestamp = message.status?.sent_at || message.updated_at;

    return (
        <Flex vertical gap={2} style={{ width: '100%', marginTop: 2 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
                <Space size={1} style={{ fontSize: '10px' }}>
                    <Text style={{
                        color: messageAbuseTagColor,
                        fontSize: '10px'
                    }}>
                        {messageTimestamp ? format(parseISO(messageTimestamp), 'HH:mm') : ''}
                    </Text>
                    {!isFacebookPolicyError && message.status && (
                        <MessageStatus
                            status={message.status}
                            isCustomerMessage={isCustomerMessage}
                            isDarkMode={isDarkMode}
                            sentAt={message.status?.sent_at}
                        />
                    )}
                    {isFacebookPolicyError && (
                        <Tooltip title={message.error_details}>
                            <Text style={{
                                color: isDarkMode ? 'rgba(255, 200, 0, 0.8)' : 'orange',
                                fontSize: '10px',
                                marginLeft: 4
                            }}>
                                ⚠️
                            </Text>
                        </Tooltip>
                    )}
                </Space>
            </div>
        </Flex>
    );
};

export default MessageMetadata;
